<div class="config-page">

  <div class="page-head">

    <div>

      <div class="eyebrow">
        MODULE CONFIG
      </div>

      <h2>
        Sub Roles
      </h2>

      <p>
        Assign application menus to roles and manage role menu access.
      </p>

    </div>


    <button
      type="button"
      class="btn-light-custom"
      (click)="loadInitialData()"
      [disabled]="loading"
    >

      <i class="bi bi-arrow-clockwise"></i>

      Refresh

    </button>

  </div>


  <div
    class="loading-box top-loader"
    *ngIf="loading"
  >

    <span
      class="spinner-border spinner-border-sm"
    ></span>

    Loading roles and menus...

  </div>


  <div
    class="mapping-card"
    *ngIf="!loading"
  >

    <div class="section-heading">

      <div class="section-icon">

        <i class="bi bi-diagram-3"></i>

      </div>


      <div>

        <h5>
          {{
            isEditMode
              ? "Edit Role Menu Mapping"
              : "Role Menu Mapping"
          }}
        </h5>

        <p>

          {{
            isEditMode
              ? "Update the menu assigned to the selected role."
              : "Select module → role → parent menu or N/A → submenu → assign."
          }}

        </p>

      </div>

    </div>


    <div class="mapping-grid">

      <!-- ====================================================== -->
      <!-- STEP 1 -->
      <!-- MODULE -->
      <!-- ====================================================== -->

      <div class="mapping-step">

        <span class="step-no">
          1
        </span>

        <label>
          Module *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedModuleName"
          (ngModelChange)="onModuleChange()"
          [disabled]="isEditMode"
        >

          <option value="">
            Select Module
          </option>

          <option
            *ngFor="
              let module of moduleOptions
            "
            [value]="module"
          >
            {{ module }}
          </option>

        </select>

      </div>


      <!-- ====================================================== -->
      <!-- STEP 2 -->
      <!-- ROLE -->
      <!-- ====================================================== -->

      <div class="mapping-step">

        <span class="step-no">
          2
        </span>

        <label>
          Role *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedRoleId"
          (ngModelChange)="onRoleChange()"
          [disabled]="
            !selectedModuleName ||
            isEditMode
          "
        >

          <option [ngValue]="0">
            Select Role
          </option>

          <option
            *ngFor="
              let role of filteredRoles
            "
            [ngValue]="role.roleId"
          >

            {{ role.roleName }}

          </option>

        </select>

      </div>


      <!-- ====================================================== -->
      <!-- STEP 3 -->
      <!-- PARENT -->
      <!-- ====================================================== -->

      <div class="mapping-step">

        <span class="step-no">
          3
        </span>

        <label>
          Parent Menu *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedParentMenuId"
          (ngModelChange)="onParentMenuChange()"
          [disabled]="
            actualSelectedRoleId <= 0 ||
            loadingMappings
          "
        >

          <option [ngValue]="0">
            Select Parent Menu
          </option>


          <option [ngValue]="-1">
            N/A - Select Sub Menu Directly
          </option>


          <option
            *ngFor="
              let menu of parentMenus
            "
            [ngValue]="menu.menuId"
          >

            {{ menu.menuName }}

          </option>

        </select>

      </div>


      <!-- ====================================================== -->
      <!-- STEP 4 -->
      <!-- SUBMENU -->
      <!-- ====================================================== -->

      <div class="mapping-step">

        <span class="step-no">
          4
        </span>

        <label>
          Sub Menu
          <span class="text-danger ms-1">*</span>
        </label>


        <select
          class="form-select"
          [(ngModel)]="selectedSubMenuId"
          [disabled]="
            selectedParentMenuId === 0
          "
        >

          <option [ngValue]="0">

            {{
              selectedParentMenuId === -1
                ? "Select Sub Menu"
                : "Parent Menu Only"
            }}

          </option>


          <option
            *ngFor="
              let menu of subMenus
            "
            [ngValue]="menu.menuId"
          >

            <ng-container
              *ngIf="
                selectedParentMenuId === -1
              "
            >

              {{
                getMenuParentName(
                  menu.parentMenuId
                )
              }}

              →

            </ng-container>

            {{ menu.menuName }}

          </option>

        </select>

      </div>


      <!-- ====================================================== -->
      <!-- ACTION -->
      <!-- ====================================================== -->

      <div class="mapping-action">

        <button
          type="button"
          class="btn-primary-custom w-100"
          [disabled]="!canAssignMenu"
          (click)="assignMenu()"
        >

          <span
            *ngIf="saving"
            class="spinner-border spinner-border-sm"
          ></span>


          <i
            *ngIf="!saving"
            class="bi"
            [ngClass]="
              isEditMode
                ? 'bi-check-lg'
                : 'bi-plus-lg'
            "
          ></i>


          {{
            saving
              ? (
                  isEditMode
                    ? "Updating..."
                    : "Assigning..."
                )
              : (
                  isEditMode
                    ? "Update Menu"
                    : "Assign Menu"
                )
          }}

        </button>


        <button
          *ngIf="isEditMode"
          type="button"
          class="btn-light-custom w-100 mt-2"
          [disabled]="saving"
          (click)="cancelEdit()"
        >

          <i class="bi bi-x-lg"></i>

          Cancel Edit

        </button>

      </div>

    </div>


    <div class="mapping-note">

      <i class="bi bi-info-circle"></i>

      When you assign a submenu, its actual parent menu is also assigned automatically.
      The selected role's actual RoleId is used internally for the mapping.

    </div>

  </div>


  <!-- ======================================================== -->
  <!-- NO MODULE -->
  <!-- ======================================================== -->

  <div
    class="empty-role-card"
    *ngIf="
      !loading &&
      !selectedModuleName
    "
  >

    <div class="empty-role-icon">

      <i class="bi bi-grid"></i>

    </div>

    <h5>
      Select a Module
    </h5>

    <p>
      Select a module first to view its roles and menus.
    </p>

  </div>


  <!-- ======================================================== -->
  <!-- NO ROLE -->
  <!-- ======================================================== -->

  <div
    class="empty-role-card"
    *ngIf="
      !loading &&
      selectedModuleName &&
      actualSelectedRoleId <= 0
    "
  >

    <div class="empty-role-icon">

      <i class="bi bi-person-lock"></i>

    </div>

    <h5>
      Select a Role
    </h5>

    <p>
      Select a role above to view and manage its assigned menus.
    </p>

  </div>


  <!-- ======================================================== -->
  <!-- ASSIGNED MENUS -->
  <!-- ======================================================== -->

  <div
    class="data-card"
    *ngIf="
      !loading &&
      actualSelectedRoleId > 0
    "
  >

    <div class="table-toolbar">

      <div>

        <h5>
          Assigned Menus
        </h5>

        <small>

          {{ selectedRoleName }}

          •

          {{ mappedMenus.length }}

          menu(s)

        </small>

      </div>


      <div class="search-box">

        <i class="bi bi-search"></i>

        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Search assigned menus..."
        />

      </div>

    </div>


    <div
      class="loading-box"
      *ngIf="loadingMappings"
    >

      <span
        class="spinner-border spinner-border-sm"
      ></span>

      Loading assigned menus...

    </div>


    <div
      class="table-responsive"
      *ngIf="!loadingMappings"
    >

      <table class="config-table">

        <thead>

          <tr>

            <th>
              Menu
            </th>

            <th>
              Type
            </th>

            <th>
              Parent
            </th>

            <th>
              Route
            </th>

            <th>
              Order
            </th>

            <th>
              Status
            </th>

            <th>
              Default
            </th>

            <th class="text-end">
              Actions
            </th>

          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let row of mappedMenus
            "
          >

            <td>

              <div class="menu-name-cell">

                <div class="table-icon">

                  <i
                    [class]="
                      row.menuIconUrl ||
                      'bi bi-grid'
                    "
                  ></i>

                </div>


                <div>

                  <strong>
                    {{ row.menuName }}
                  </strong>

                  <small>
                    {{ row.menuCode }}
                  </small>

                </div>

              </div>

            </td>


            <td>

              <span
                class="type-badge parent"
                *ngIf="
                  row.parentMenuId === 0
                "
              >
                Parent
              </span>


              <span
                class="type-badge child"
                *ngIf="
                  row.parentMenuId > 0
                "
              >
                Sub Menu
              </span>

            </td>


            <td>
              {{ row.parentMenuName }}
            </td>


            <td>

              <code>

                {{
                  row.templatePath ||
                  "-"
                }}

              </code>

            </td>


            <td>
              {{ row.displayOrder }}
            </td>


            <td>

              <span
                class="status active"
                *ngIf="
                  row.isActive === 1
                "
              >
                Active
              </span>


              <span
                class="status inactive"
                *ngIf="
                  row.isActive !== 1
                "
              >
                Inactive
              </span>

            </td>


            <td>

              <span
                class="default-badge"
                *ngIf="
                  row.isDefault === 1
                "
              >
                Yes
              </span>


              <span
                *ngIf="
                  row.isDefault !== 1
                "
              >
                -
              </span>

            </td>


            <td class="text-end">

              <!-- ============================================== -->
              <!-- EDIT -->
              <!-- ============================================== -->

              <button
                type="button"
                class="icon-btn edit"
                title="Edit"
                (click)="editMapping(row)"
              >

                <i class="bi bi-pencil"></i>

              </button>


              <!-- ============================================== -->
              <!-- ENABLE / DISABLE -->
              <!-- ============================================== -->

              <button
                type="button"
                class="icon-btn status-action"
                [title]="
                  row.isActive === 1
                    ? 'Disable'
                    : 'Enable'
                "
                (click)="toggleMapping(row)"
              >

                <i
                  class="bi"
                  [ngClass]="
                    row.isActive === 1
                      ? 'bi-pause-circle'
                      : 'bi-play-circle'
                  "
                ></i>

              </button>


              <!-- ============================================== -->
              <!-- DELETE -->
              <!-- ============================================== -->

              <button
                type="button"
                class="icon-btn delete"
                title="Remove"
                (click)="removeMapping(row)"
              >

                <i class="bi bi-trash"></i>

              </button>

            </td>

          </tr>


          <tr
            *ngIf="
              mappedMenus.length === 0
            "
          >

            <td
              colspan="8"
              class="empty-cell"
            >

              No menus assigned to this role.

            </td>

          </tr>

        </tbody>

      </table>

    </div>

  </div>

</div>